import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wk94as365j: FaireBrandEntity = {
  token: "b_wk94as365j",
  type: "brand",
  name: "Axesoria West",
  avatarUrl:
    "https://cdn.faire.com/fastly/380e2ce1032626c7e090678daae5cf59f516bb0fc680786e4b0610c4ae7d4e64.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/d8a8b5161e7f241ff0234db651cfa51ef8cf820e0672993907b1453bbcfe99b2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/380e2ce1032626c7e090678daae5cf59f516bb0fc680786e4b0610c4ae7d4e64.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d8a8b5161e7f241ff0234db651cfa51ef8cf820e0672993907b1453bbcfe99b2.jpeg",
  location: "Commerce, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 107,
  isTopShop: true,
  isInsider: true,
  description:
    "Axesoria West is an accessory brand that strive to create and offer customer products that are unique, in great quality, and most of all, at affordable price. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.824Z",
    importedBy: "entity-db-cli",
  },
};
